<template lang="pug">
</template>

<script>
export default {
  name: "AcceptInvite",
  data: () => ({
  }),
  created () {
    this.$store.commit('user/setUser', null)
    let token = this.$route.params.token
    this.$axios.get(`/invitations/${token}/`)
      .then(resp => {
        let invitation = resp.data
        if (invitation.expired) {
          this.$router.push('/')
        }
        if (invitation.email) {
          this.$axios.get(`/users/check_email/?email=${encodeURIComponent(invitation.email)}`)
              .then(resp => {
                if (resp.data.available) {
                  this.$router.push({ name: 'InviteSignUp', params: { invitation: invitation, token: token }})
                } else {
                  this.$axios.post('/users/verify_email_by_invite_token/', { invite_token: token })
                  this.$router.push({ name: 'SignIn', params: { invitation: invitation }})
                }
              })
              .catch(() => {
                this.$router.push('/')
              })
        } else if (invitation.phone) {
          this.$axios.get(`/users/check_phone/?phone=${encodeURIComponent(invitation.phone)}`)
              .then(resp => {
                if (resp.data.available) {
                  this.$router.push({ name: 'InviteSignUp', params: { invitation: invitation, token: token }})
                } else {
                  this.$router.push({ name: 'SignIn', params: { invitation: invitation }})
                }
              })
              .catch(() => {
                this.$router.push('/')
              })
        } else {
          this.$router.push('/')
        }
      })
      .catch(() => {
        this.$router.push('/')
      })
  }
}
</script>

<style lang="scss" scoped>

</style>